<section class="template-section">
  <dx-select-box [items]="dropdownEntries" displayExpr="label" valueExpr="key" [value]="current?.key"
                 [class.param-changed]="different"
                 [disabled]="locked" placeholder="Choose a Template…" itemTemplate="templateOption"
                 (onValueChanged)="choose($event)">
    <div *dxTemplate="let entry of 'templateOption'" class="template-option"
         (click)="reselect(entry.key)">{{entry.label}}</div>
  </dx-select-box>
  <div class="actions template-actions">
    <dx-button text="Save" type="default" width="100%" [disabled]="locked || !writable || saveProblems.length > 0" (onClick)="save()"></dx-button>
    <dx-button text="Save New" type="success" width="100%" [disabled]="locked || saveProblems.length > 0" (onClick)="openEditor('new')"></dx-button>
    <dx-button text="Edit" type="normal" width="100%" [disabled]="locked || !writable" (onClick)="openEditor('edit')"></dx-button>
    <dx-button text="Delete" type="danger" width="100%" [disabled]="locked || !writable" (onClick)="requestDelete()"></dx-button>
  </div>
  <dx-button *ngIf="canManage" text="Assign Templates" width="100%" [disabled]="locked" (onClick)="openAssignments()"></dx-button>
  <p *ngIf="error" class="error">{{error}}</p>
  <ng-container *ngIf="underlying"><p *ngFor="let problem of saveProblems" class="error">{{problem}}</p></ng-container>
  <dx-button *ngIf="error" text="Reload Templates" [disabled]="busy || disabled" (onClick)="reload(true)"></dx-button>
</section>
<dx-popup [visible]="!!editor" titleTemplate="editorTitle" [wrapperAttr]="{class: 'maven-template-popup'}"
          [width]="440" [height]="'auto'" [closeOnOutsideClick]="false" [showCloseButton]="false" (onHidden)="closeEditor()">
  <div *dxTemplate="let data of 'editorTitle'" class="template-popup-title">
    <span>{{editor === 'new' ? 'Save New Template' : 'Edit Template'}}</span>
    <dx-button icon="close" stylingMode="text" [disabled]="busy" (onClick)="closeEditor()"></dx-button>
  </div>
  <div *dxTemplate="let data of 'content'" class="template-editor">
    <div class="template-editor-fields">
      <dx-text-box [value]="name" (onValueChanged)="onNameChanged($event)" valueChangeEvent="input"
                   [disabled]="busy" [maxLength]="200" placeholder="Template Name"></dx-text-box>
      <dx-check-box *ngIf="canShare" [value]="shared" (onValueChanged)="onSharedChanged($event)"
                    [disabled]="busy" text="Assignable Template"></dx-check-box>
      <p *ngIf="editor === 'edit' && current?.scope === 'shared' && !shared">Making This Template Personal Removes the Shared Source and Its Assignments.</p>
      <p *ngIf="error" class="error">{{error}}</p>
      <ng-container *ngIf="editor === 'new'"><p *ngFor="let problem of saveProblems" class="error">{{problem}}</p></ng-container>
    </div>
    <div class="template-editor-footer">
      <dx-button text="Save" type="success" width="100%" [disabled]="locked || (editor === 'new' && saveProblems.length > 0)" (onClick)="save(true)"></dx-button>
      <dx-button text="Cancel" type="danger" width="100%" [disabled]="busy" (onClick)="closeEditor()"></dx-button>
    </div>
  </div>
</dx-popup>
<dx-popup [visible]="deleting" title="Delete Template" [width]="360" [height]="'auto'"
          [closeOnOutsideClick]="false" [showCloseButton]="!busy" (onHidden)="cancelDelete()">
  <div *dxTemplate="let data of 'content'">
    <p>Delete {{current?.template.name}}?</p>
    <p *ngIf="current?.scope === 'shared'">Assigned Users Will Lose Access to This Template.</p>
    <p *ngIf="error" class="error">{{error}}</p>
    <div class="actions"><dx-button text="Delete" [disabled]="busy" (onClick)="remove()"></dx-button>
      <dx-button text="Cancel" [disabled]="busy" (onClick)="cancelDelete()"></dx-button></div>
  </div>
</dx-popup>
<dx-popup [visible]="assigning" titleTemplate="assignmentTitle" [wrapperAttr]="{class: 'maven-template-popup'}" [width]="600" [height]="460"
          [closeOnOutsideClick]="false" [showCloseButton]="false" (onHidden)="closeAssignments()">
  <div *dxTemplate="let data of 'assignmentTitle'" class="template-popup-title">
    <span>Assign Maven Templates</span>
    <dx-button icon="close" stylingMode="text" [disabled]="busy" (onClick)="closeAssignments()"></dx-button>
  </div>
  <div *dxTemplate="let data of 'content'" class="assignments">
    <div class="assignment-columns">
      <div class="assignment-column">
        <h3>TEMPLATES</h3>
        <dx-list [dataSource]="assignmentGroups" [grouped]="true" displayExpr="name"
                 selectionMode="single" [showSelectionControls]="false" [disabled]="busy"
                 [(selectedItems)]="selectedAssignments" (onSelectionChanged)="assignmentSelectionChanged()"
                 noDataText="No Shared Templates."></dx-list>
      </div>
      <div class="assignment-column">
        <h3>USERS</h3>
        <dx-list [dataSource]="selectedAssignment?.users || []" [disabled]="busy"
                 [noDataText]="selectedAssignment ? 'No Available Users.' : 'Select a Template.'">
          <div *dxTemplate="let user of 'item'">
            <dx-check-box [(value)]="user.isSelected" [text]="user.name" [disabled]="busy"></dx-check-box>
          </div>
        </dx-list>
      </div>
    </div>
    <p *ngIf="error" class="error">{{error}}</p>
    <div class="actions assignment-footer"><dx-button text="Save Changes" [disabled]="busy || !assignments.length" (onClick)="saveAssignments()"></dx-button>
      <dx-button text="Cancel" [disabled]="busy" (onClick)="closeAssignments()"></dx-button></div>
  </div>
</dx-popup>
<dx-load-panel [visible]="busy" [message]="loadingMessage" [shading]="true"
               [closeOnOutsideClick]="false"></dx-load-panel>
